module.exports = __webpack_public_path__ + "img/s11-txt1.066744ae.png";